
export const mockGuidelines = [
  {
    id: '1',
    title: 'Conventional Loan Income Requirements and Documentation Standards',
    source: 'Fannie Mae',
    category: 'Income & Employment',
    description: 'Comprehensive guidelines for verifying borrower income including salary, self-employment, rental income, and other sources. Covers documentation requirements, calculation methods, and acceptable income types for conventional mortgage loans.',
    lastUpdated: '2024-01-15',
    tags: ['Income Verification', 'Employment', 'Documentation', 'Conventional Loans', 'DTI Ratio'],
    url: 'https://fanniemae.com/guidelines'
  },
  {
    id: '2',
    title: 'Credit Score Requirements and Risk Assessment Guidelines',
    source: 'Freddie Mac',
    category: 'Credit & Risk',
    description: 'Detailed credit scoring requirements including minimum FICO scores, credit history evaluation, and compensating factors. Includes guidelines for borrowers with limited credit history and credit repair documentation.',
    lastUpdated: '2024-01-12',
    tags: ['Credit Score', 'FICO', 'Risk Assessment', 'Credit History', 'Compensating Factors'],
    url: 'https://freddiemac.com/guidelines'
  },
  {
    id: '3',
    title: 'FHA Loan Property Standards and Appraisal Requirements',
    source: 'HUD',
    category: 'Property & Appraisal',
    description: 'Federal Housing Administration guidelines for property eligibility, appraisal standards, and safety requirements. Covers manufactured homes, condominiums, and single-family properties under FHA programs.',
    lastUpdated: '2024-01-10',
    tags: ['FHA', 'Property Standards', 'Appraisal', 'Safety Requirements', 'Manufactured Homes'],
    url: 'https://hud.gov/guidelines'
  },
  {
    id: '4',
    title: 'VA Loan Eligibility and Certificate of Eligibility Requirements',
    source: 'VA',
    category: 'Eligibility & Benefits',
    description: 'Veterans Affairs loan eligibility criteria including service requirements, Certificate of Eligibility process, and entitlement calculations. Covers active duty, veterans, and surviving spouses eligibility standards.',
    lastUpdated: '2024-01-08',
    tags: ['VA Loans', 'Eligibility', 'Certificate of Eligibility', 'Veterans', 'Service Requirements'],
    url: 'https://va.gov/guidelines'
  },
  {
    id: '5',
    title: 'Debt-to-Income Ratio Calculations and Acceptable Debt Types',
    source: 'Fannie Mae',
    category: 'Income & Employment',
    description: 'Guidelines for calculating front-end and back-end debt-to-income ratios, including acceptable debt types, exclusions, and compensating factors for higher DTI ratios in conventional lending.',
    lastUpdated: '2024-01-05',
    tags: ['DTI Ratio', 'Debt Calculation', 'Compensating Factors', 'Front-end Ratio', 'Back-end Ratio'],
    url: 'https://fanniemae.com/guidelines'
  },
  {
    id: '6',
    title: 'Automated Underwriting System Guidelines and Override Conditions',
    source: 'Freddie Mac',
    category: 'Underwriting',
    description: 'Loan Prospector automated underwriting guidelines including system recommendations, manual underwriting triggers, and conditions for overriding automated decisions in the underwriting process.',
    lastUpdated: '2024-01-03',
    tags: ['Automated Underwriting', 'Loan Prospector', 'Manual Underwriting', 'System Override', 'AUS'],
    url: 'https://freddiemac.com/guidelines'
  },
  {
    id: '7',
    title: 'FHA Mortgage Insurance Premium Structure and Calculations',
    source: 'HUD',
    category: 'Insurance & Fees',
    description: 'Federal Housing Administration mortgage insurance premium guidelines including upfront and annual premium calculations, cancellation criteria, and premium refund policies for FHA-insured loans.',
    lastUpdated: '2023-12-28',
    tags: ['FHA', 'Mortgage Insurance', 'Premium Calculation', 'MIP', 'Insurance Cancellation'],
    url: 'https://hud.gov/guidelines'
  },
  {
    id: '8',
    title: 'VA Funding Fee Structure and Exemption Criteria',
    source: 'VA',
    category: 'Fees & Costs',
    description: 'Veterans Affairs funding fee guidelines including fee percentages, exemption criteria for disabled veterans, and fee calculations for different loan types and down payment amounts.',
    lastUpdated: '2023-12-25',
    tags: ['VA Funding Fee', 'Fee Exemption', 'Disabled Veterans', 'Fee Calculation', 'Down Payment'],
    url: 'https://va.gov/guidelines'
  },
  {
    id: '9',
    title: 'Condominium Project Approval and Warrantability Standards',
    source: 'Fannie Mae',
    category: 'Property & Appraisal',
    description: 'Guidelines for condominium project approval including warrantability requirements, HOA financial review, owner-occupancy ratios, and project concentration limits for conventional loans.',
    lastUpdated: '2023-12-22',
    tags: ['Condominiums', 'Project Approval', 'Warrantability', 'HOA Review', 'Owner Occupancy'],
    url: 'https://fanniemae.com/guidelines'
  },
  {
    id: '10',
    title: 'Self-Employed Borrower Income Documentation and Verification',
    source: 'Freddie Mac',
    category: 'Income & Employment',
    description: 'Comprehensive guidelines for documenting and verifying self-employed borrower income including tax returns, profit and loss statements, and business financial documentation requirements.',
    lastUpdated: '2023-12-20',
    tags: ['Self-Employed', 'Income Documentation', 'Tax Returns', 'P&L Statements', 'Business Income'],
    url: 'https://freddiemac.com/guidelines'
  },
  {
    id: '11',
    title: 'FHA Cash-Out Refinance Guidelines and Restrictions',
    source: 'HUD',
    category: 'Refinancing',
    description: 'Federal Housing Administration cash-out refinance guidelines including loan-to-value limits, seasoning requirements, and cash-out restrictions for FHA-insured refinance transactions.',
    lastUpdated: '2023-12-18',
    tags: ['FHA', 'Cash-Out Refinance', 'LTV Limits', 'Seasoning Requirements', 'Refinancing'],
    url: 'https://hud.gov/guidelines'
  },
  {
    id: '12',
    title: 'VA Interest Rate Reduction Refinance Loan (IRRRL) Requirements',
    source: 'VA',
    category: 'Refinancing',
    description: 'Veterans Affairs streamline refinance guidelines including net tangible benefit requirements, seasoning periods, and documentation standards for VA Interest Rate Reduction Refinance Loans.',
    lastUpdated: '2023-12-15',
    tags: ['VA IRRRL', 'Streamline Refinance', 'Net Tangible Benefit', 'Seasoning', 'Rate Reduction'],
    url: 'https://va.gov/guidelines'
  },
  {
    id: '13',
    title: 'Fannie Mae Appraisal Standards and Property Valuation Requirements',
    source: 'Fannie Mae',
    category: 'Property & Appraisal',
    description: 'Complete Fannie Mae appraisal guidelines including Uniform Standards of Professional Appraisal Practice (USPAP) compliance, comparable sales analysis, property condition requirements, and appraisal review standards for conventional loans.',
    lastUpdated: '2024-01-20',
    tags: ['Fannie Mae', 'Appraisal Standards', 'USPAP', 'Comparable Sales', 'Property Valuation', 'Appraisal Review'],
    url: 'https://fanniemae.com/guidelines'
  },
  {
    id: '14',
    title: 'Freddie Mac Property Valuation and Appraisal Quality Standards',
    source: 'Freddie Mac',
    category: 'Property & Appraisal',
    description: 'Freddie Mac appraisal requirements including Home Valuation Code of Conduct compliance, appraiser independence standards, property inspection requirements, and automated valuation model (AVM) usage guidelines.',
    lastUpdated: '2024-01-18',
    tags: ['Freddie Mac', 'Property Valuation', 'HVCC', 'Appraiser Independence', 'AVM', 'Property Inspection'],
    url: 'https://freddiemac.com/guidelines'
  },
  {
    id: '15',
    title: 'FHA Appraisal Requirements and Property Condition Standards',
    source: 'HUD',
    category: 'Property & Appraisal',
    description: 'Federal Housing Administration comprehensive appraisal guidelines including FHA-approved appraiser requirements, property safety and soundness standards, repair requirements, and appraisal update procedures.',
    lastUpdated: '2024-01-16',
    tags: ['FHA Appraisal', 'Property Condition', 'Safety Standards', 'Repair Requirements', 'FHA Appraiser'],
    url: 'https://hud.gov/guidelines'
  },
  {
    id: '16',
    title: 'VA Property Appraisal and Minimum Property Requirements (MPRs)',
    source: 'VA',
    category: 'Property & Appraisal',
    description: 'Veterans Affairs appraisal standards including VA-approved appraiser requirements, Minimum Property Requirements, Certificate of Reasonable Value (CRV) process, and property condition assessments.',
    lastUpdated: '2024-01-14',
    tags: ['VA Appraisal', 'MPR', 'Certificate of Reasonable Value', 'VA Appraiser', 'Property Requirements'],
    url: 'https://va.gov/guidelines'
  },
  {
    id: '17',
    title: 'Fannie Mae Desktop Underwriter Property Inspection Waiver (PIW) Guidelines',
    source: 'Fannie Mae',
    category: 'Property & Appraisal',
    description: 'Guidelines for Property Inspection Waiver eligibility including automated valuation criteria, property data requirements, loan risk assessment, and PIW acceptance standards for conventional loans.',
    lastUpdated: '2024-01-12',
    tags: ['PIW', 'Property Inspection Waiver', 'Desktop Underwriter', 'Automated Valuation', 'Risk Assessment'],
    url: 'https://fanniemae.com/guidelines'
  },
  {
    id: '18',
    title: 'Freddie Mac Automated Collateral Evaluation (ACE) and Appraisal Waivers',
    source: 'Freddie Mac',
    category: 'Property & Appraisal',
    description: 'Freddie Mac guidelines for Automated Collateral Evaluation including waiver eligibility, property data verification, collateral risk assessment, and ACE acceptance criteria for qualified transactions.',
    lastUpdated: '2024-01-10',
    tags: ['ACE', 'Automated Collateral Evaluation', 'Appraisal Waiver', 'Collateral Risk', 'Property Data'],
    url: 'https://freddiemac.com/guidelines'
  },
  {
    id: '19',
    title: 'FHA Property Flip Restrictions and Anti-Flipping Guidelines',
    source: 'HUD',
    category: 'Property & Appraisal',
    description: 'Federal Housing Administration property flipping restrictions including 90-day anti-flipping rule, exceptions for inherited properties, and additional appraisal requirements for recently sold properties.',
    lastUpdated: '2024-01-08',
    tags: ['Property Flipping', 'Anti-Flipping Rule', '90-Day Rule', 'Inherited Properties', 'Recent Sales'],
    url: 'https://hud.gov/guidelines'
  },
  {
    id: '20',
    title: 'VA Tidewater Initiative and Reconsideration of Value Process',
    source: 'VA',
    category: 'Property & Appraisal',
    description: 'Veterans Affairs Tidewater Initiative guidelines including appraised value notification process, reconsideration of value procedures, and additional comparable sales submission requirements.',
    lastUpdated: '2024-01-06',
    tags: ['Tidewater Initiative', 'Reconsideration of Value', 'ROV', 'Value Notification', 'Comparable Sales'],
    url: 'https://va.gov/guidelines'
  },
  {
    id: '21',
    title: 'Fannie Mae Manufactured Housing Appraisal and Classification Standards',
    source: 'Fannie Mae',
    category: 'Property & Appraisal',
    description: 'Comprehensive guidelines for manufactured housing appraisals including real estate vs personal property classification, foundation requirements, HUD Code compliance, and comparable sales analysis for manufactured homes.',
    lastUpdated: '2024-01-04',
    tags: ['Manufactured Housing', 'HUD Code', 'Foundation Requirements', 'Real Estate Classification', 'Mobile Homes'],
    url: 'https://fanniemae.com/guidelines'
  },
  {
    id: '22',
    title: 'Freddie Mac Condominium Appraisal and Project Review Standards',
    source: 'Freddie Mac',
    category: 'Property & Appraisal',
    description: 'Freddie Mac condominium appraisal requirements including project warrantability review, comparable sales analysis for condos, HOA financial assessment, and unit-specific valuation standards.',
    lastUpdated: '2024-01-02',
    tags: ['Condominium Appraisal', 'Project Warrantability', 'HOA Financial Review', 'Condo Comparables', 'Unit Valuation'],
    url: 'https://freddiemac.com/guidelines'
  },
  {
    id: '23',
    title: 'FHA Condominium Project Approval and Appraisal Requirements',
    source: 'HUD',
    category: 'Property & Appraisal',
    description: 'Federal Housing Administration condominium guidelines including FHA-approved project requirements, spot loan criteria, condominium appraisal standards, and project recertification procedures.',
    lastUpdated: '2023-12-30',
    tags: ['FHA Condominiums', 'Project Approval', 'Spot Loans', 'Condo Appraisal', 'Project Recertification'],
    url: 'https://hud.gov/guidelines'
  },
  {
    id: '24',
    title: 'VA Condominium and PUD Appraisal Guidelines',
    source: 'VA',
    category: 'Property & Appraisal',
    description: 'Veterans Affairs guidelines for condominium and Planned Unit Development appraisals including project approval requirements, common area assessments, and special valuation considerations for shared ownership properties.',
    lastUpdated: '2023-12-28',
    tags: ['VA Condominiums', 'PUD', 'Planned Unit Development', 'Common Areas', 'Shared Ownership'],
    url: 'https://va.gov/guidelines'
  },
  {
    id: '25',
    title: 'Fannie Mae Rural Property and Unique Property Appraisal Standards',
    source: 'Fannie Mae',
    category: 'Property & Appraisal',
    description: 'Guidelines for appraising rural and unique properties including expanded comparable sales search areas, special use properties, agricultural land considerations, and alternative valuation methods.',
    lastUpdated: '2023-12-26',
    tags: ['Rural Properties', 'Unique Properties', 'Agricultural Land', 'Special Use', 'Alternative Valuation'],
    url: 'https://fanniemae.com/guidelines'
  },
  {
    id: '26',
    title: 'Freddie Mac Appraisal Quality Control and Review Standards',
    source: 'Freddie Mac',
    category: 'Property & Appraisal',
    description: 'Freddie Mac appraisal quality control guidelines including post-closing appraisal review, quality scoring systems, appraiser performance monitoring, and corrective action procedures.',
    lastUpdated: '2023-12-24',
    tags: ['Appraisal Quality Control', 'Post-Closing Review', 'Quality Scoring', 'Appraiser Performance', 'Corrective Action'],
    url: 'https://freddiemac.com/guidelines'
  },
  {
    id: '27',
    title: 'FHA Appraisal Update and Completion Requirements',
    source: 'HUD',
    category: 'Property & Appraisal',
    description: 'Federal Housing Administration guidelines for appraisal updates including completion of construction requirements, appraisal aging limits, property condition changes, and re-inspection procedures.',
    lastUpdated: '2023-12-22',
    tags: ['Appraisal Updates', 'Construction Completion', 'Appraisal Aging', 'Re-inspection', 'Property Changes'],
    url: 'https://hud.gov/guidelines'
  },
  {
    id: '28',
    title: 'VA Energy Efficiency and Green Building Appraisal Considerations',
    source: 'VA',
    category: 'Property & Appraisal',
    description: 'Veterans Affairs guidelines for appraising energy-efficient and green building features including renewable energy systems, energy-efficient improvements, and environmental impact considerations in property valuation.',
    lastUpdated: '2023-12-20',
    tags: ['Energy Efficiency', 'Green Building', 'Renewable Energy', 'Environmental Impact', 'Sustainable Features'],
    url: 'https://va.gov/guidelines'
  },
  // New ADU and Multi-Family Property Guidelines
  {
    id: '29',
    title: 'Fannie Mae Accessory Dwelling Unit (ADU) Guidelines and Requirements',
    source: 'Fannie Mae',
    category: 'Property & Appraisal',
    description: 'Comprehensive guidelines for properties with Accessory Dwelling Units including rental income calculations, property classification, zoning compliance, and appraisal considerations for ADUs and in-law suites.',
    lastUpdated: '2024-01-25',
    tags: ['ADU', 'Accessory Dwelling Unit', 'Rental Income', 'In-law Suite', 'Zoning Compliance', 'Property Classification'],
    url: 'https://fanniemae.com/guidelines'
  },
  {
    id: '30',
    title: 'Freddie Mac Two-to- Four Unit Property Guidelines and Investment Property Standards',
    source: 'Freddie Mac',
    category: 'Property & Appraisal',
    description: 'Guidelines for financing two-to-four unit properties including duplex, triplex, and fourplex requirements, rental income verification, property management considerations, and investment property loan standards.',
    lastUpdated: '2024-01-23',
    tags: ['2-4 Unit Properties', 'Duplex', 'Triplex', 'Fourplex', 'Investment Property', 'Rental Income Verification'],
    url: 'https://freddiemac.com/guidelines'
  },
  {
    id: '31',
    title: 'FHA Two-Family Property and Duplex Financing Requirements',
    source: 'HUD',
    category: 'Property & Appraisal',
    description: 'Federal Housing Administration guidelines for two-family properties including owner-occupancy requirements, rental income calculations, property condition standards, and duplex appraisal requirements.',
    lastUpdated: '2024-01-21',
    tags: ['Two-Family Property', 'Duplex Financing', 'Owner Occupancy', 'FHA Duplex', 'Rental Income'],
    url: 'https://hud.gov/guidelines'
  },
  {
    id: '32',
    title: 'VA Multi-Unit Property Guidelines and Rental Income Standards',
    source: 'VA',
    category: 'Property & Appraisal',
    description: 'Veterans Affairs guidelines for multi-unit properties including two-to-four unit financing, rental income verification, property management requirements, and VA-specific multi-family standards.',
    lastUpdated: '2024-01-19',
    tags: ['VA Multi-Unit', 'Multi-Family Property', 'Rental Income Standards', 'Property Management'],
    url: 'https://va.gov/guidelines'
  },
  {
    id: '33',
    title: 'Fannie Mae Outbuilding and Detached Structure Guidelines',
    source: 'Fannie Mae',
    category: 'Property & Appraisal',
    description: 'Guidelines for properties with outbuildings including detached garages, workshops, barns, and other structures. Covers contribution to value, safety requirements, and appraisal considerations for detached improvements.',
    lastUpdated: '2024-01-17',
    tags: ['Outbuildings', 'Detached Structures', 'Detached Garage', 'Workshop', 'Barn', 'Property Improvements'],
    url: 'https://fanniemae.com/guidelines'
  },
  {
    id: '34',
    title: 'Freddie Mac Accessory Structure and Outbuilding Valuation Standards',
    source: 'Freddie Mac',
    category: 'Property & Appraisal',
    description: 'Freddie Mac guidelines for valuing accessory structures including guest houses, pool houses, detached workshops, and agricultural buildings. Includes safety inspections and contribution to property value assessments.',
    lastUpdated: '2024-01-15',
    tags: ['Accessory Structures', 'Guest House', 'Pool House', 'Agricultural Buildings', 'Structure Valuation'],
    url: 'https://freddiemac.com/guidelines'
  },
  {
    id: '35',
    title: 'FHA Accessory Building and Detached Structure Requirements',
    source: 'HUD',
    category: 'Property & Appraisal',
    description: 'Federal Housing Administration requirements for accessory buildings including safety standards, structural integrity, and contribution to property value. Covers sheds, detached garages, and other outbuildings.',
    lastUpdated: '2024-01-13',
    tags: ['FHA Accessory Buildings', 'Detached Structures', 'Safety Standards', 'Structural Integrity', 'Sheds'],
    url: 'https://hud.gov/guidelines'
  },
  {
    id: '36',
    title: 'VA Outbuilding and Agricultural Property Guidelines',
    source: 'VA',
    category: 'Property & Appraisal',
    description: 'Veterans Affairs guidelines for properties with outbuildings and agricultural features including barns, silos, equipment buildings, and farm structures. Covers rural property considerations and agricultural use assessments.',
    lastUpdated: '2024-01-11',
    tags: ['VA Outbuildings', 'Agricultural Property', 'Farm Structures', 'Rural Property', 'Agricultural Use'],
    url: 'https://va.gov/guidelines'
  },
  {
    id: '37',
    title: 'Fannie Mae In-Law Suite and Multigenerational Housing Guidelines',
    source: 'Fannie Mae',
    category: 'Property & Appraisal',
    description: 'Guidelines for properties with in-law suites and multigenerational housing features including separate entrances, kitchen facilities, rental income potential, and family use considerations.',
    lastUpdated: '2024-01-09',
    tags: ['In-Law Suite', 'Multigenerational Housing', 'Separate Entrance', 'Kitchen Facilities', 'Family Use'],
    url: 'https://fanniemae.com/guidelines'
  },
  {
    id: '38',
    title: 'Freddie Mac Small Multi-Family Property Investment Guidelines',
    source: 'Freddie Mac',
    category: 'Property & Appraisal',
    description: 'Investment property guidelines for small multi-family properties including cash flow analysis, property management requirements, market rent verification, and investor qualification standards.',
    lastUpdated: '2024-01-07',
    tags: ['Small Multi-Family', 'Investment Guidelines', 'Cash Flow Analysis', 'Market Rent', 'Investor Qualification'],
    url: 'https://freddiemac.com/guidelines'
  },
  {
    id: '39',
    title: 'FHA ADU and Accessory Dwelling Unit Financing Standards',
    source: 'HUD',
    category: 'Property & Appraisal',
    description: 'Federal Housing Administration standards for financing properties with ADUs including legal conformity, rental income calculations, owner-occupancy requirements, and ADU-specific appraisal guidelines.',
    lastUpdated: '2024-01-05',
    tags: ['FHA ADU', 'ADU Financing', 'Legal Conformity', 'ADU Appraisal', 'ADU Rental Income'],
    url: 'https://hud.gov/guidelines'
  },
  {
    id: '40',
    title: 'VA Accessory Dwelling Unit and Secondary Housing Guidelines',
    source: 'VA',
    category: 'Property & Appraisal',
    description: 'Veterans Affairs guidelines for properties with accessory dwelling units and secondary housing including rental income verification, property use restrictions, and VA-specific ADU requirements.',
    lastUpdated: '2024-01-03',
    tags: ['VA ADU', 'Secondary Housing', 'ADU Requirements', 'Property Use Restrictions', 'VA Rental Income'],
    url: 'https://va.gov/guidelines'
  }
];

export const categories = [
  'Income & Employment',
  'Credit & Risk',
  'Property & Appraisal',
  'Eligibility & Benefits',
  'Underwriting',
  'Insurance & Fees',
  'Fees & Costs',
  'Refinancing'
];

export const allTags = [
  'Income Verification', 'Employment', 'Documentation', 'Conventional Loans', 'DTI Ratio',
  'Credit Score', 'FICO', 'Risk Assessment', 'Credit History', 'Compensating Factors',
  'FHA', 'Property Standards', 'Appraisal', 'Safety Requirements', 'Manufactured Homes',
  'VA Loans', 'Eligibility', 'Certificate of Eligibility', 'Veterans', 'Service Requirements',
  'Debt Calculation', 'Front-end Ratio', 'Back-end Ratio', 'Automated Underwriting',
  'Loan Prospector', 'Manual Underwriting', 'System Override', 'AUS', 'Mortgage Insurance',
  'Premium Calculation', 'MIP', 'Insurance Cancellation', 'VA Funding Fee', 'Fee Exemption',
  'Disabled Veterans', 'Fee Calculation', 'Down Payment', 'Condominiums', 'Project Approval',
  'Warrantability', 'HOA Review', 'Owner Occupancy', 'Self-Employed', 'Tax Returns',
  'P&L Statements', 'Business Income', 'Cash-Out Refinance', 'LTV Limits', 'Seasoning Requirements',
  'Refinancing', 'VA IRRRL', 'Streamline Refinance', 'Net Tangible Benefit', 'Rate Reduction',
  // Existing Appraisal Tags
  'Fannie Mae', 'Appraisal Standards', 'USPAP', 'Comparable Sales', 'Property Valuation', 'Appraisal Review',
  'Freddie Mac', 'HVCC', 'Appraiser Independence', 'AVM', 'Property Inspection',
  'FHA Appraisal', 'Property Condition', 'Safety Standards', 'Repair Requirements', 'FHA Appraiser',
  'VA Appraisal', 'MPR', 'Certificate of Reasonable Value', 'VA Appraiser', 'Property Requirements',
  'PIW', 'Property Inspection Waiver', 'Desktop Underwriter', 'Automated Valuation',
  'ACE', 'Automated Collateral Evaluation', 'Appraisal Waiver', 'Collateral Risk', 'Property Data',
  'Property Flipping', 'Anti-Flipping Rule', '90-Day Rule', 'Inherited Properties', 'Recent Sales',
  'Tidewater Initiative', 'Reconsideration of Value', 'ROV', 'Value Notification',
  'HUD Code', 'Foundation Requirements', 'Real Estate Classification', 'Mobile Homes',
  'Condominium Appraisal', 'Project Warrantability', 'HOA Financial Review', 'Condo Comparables', 'Unit Valuation',
  'FHA Condominiums', 'Spot Loans', 'Condo Appraisal', 'Project Recertification',
  'VA Condominiums', 'PUD', 'Planned Unit Development', 'Common Areas', 'Shared Ownership',
  'Rural Properties', 'Unique Properties', 'Agricultural Land', 'Special Use', 'Alternative Valuation',
  'Appraisal Quality Control', 'Post-Closing Review', 'Quality Scoring', 'Appraiser Performance', 'Corrective Action',
  'Appraisal Updates', 'Construction Completion', 'Appraisal Aging', 'Re-inspection', 'Property Changes',
  'Energy Efficiency', 'Green Building', 'Renewable Energy', 'Environmental Impact', 'Sustainable Features',
  // New ADU and Multi-Family Tags
  'ADU', 'Accessory Dwelling Unit', 'Rental Income', 'In-law Suite', 'Zoning Compliance', 'Property Classification',
  '2-4 Unit Properties', 'Duplex', 'Triplex', 'Fourplex', 'Investment Property', 'Rental Income Verification',
  'Two-Family Property', 'Duplex Financing', 'Owner Occupancy', 'FHA Duplex',
  'VA Multi-Unit', 'Multi-Family Property', 'Rental Income Standards', 'Property Management',
  'Outbuildings', 'Detached Structures', 'Detached Garage', 'Workshop', 'Barn', 'Property Improvements',
  'Accessory Structures', 'Guest House', 'Pool House', 'Agricultural Buildings', 'Structure Valuation',
  'FHA Accessory Buildings', 'Safety Standards', 'Structural Integrity', 'Sheds',
  'VA Outbuildings', 'Agricultural Property', 'Farm Structures', 'Rural Property', 'Agricultural Use',
  'Multigenerational Housing', 'Separate Entrance', 'Kitchen Facilities', 'Family Use',
  'Small Multi-Family', 'Investment Guidelines', 'Cash Flow Analysis', 'Market Rent', 'Investor Qualification',
  'FHA ADU', 'ADU Financing', 'Legal Conformity', 'ADU Appraisal', 'ADU Rental Income',
  'VA ADU', 'Secondary Housing', 'ADU Requirements', 'Property Use Restrictions', 'VA Rental Income'
];
